import { StateCreator } from "zustand";

// --- State Type ---
export type MobileMenuSliceState = {
  isMobileMenuOpen: boolean;
};

// --- Actions Type ---
export type MobileMenuSliceActions = {
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
};

// --- Combined Type ---
export type MobileMenuSlice = MobileMenuSliceState & MobileMenuSliceActions;

// --- Initial State ---
export const initialMobileMenuState: MobileMenuSliceState = {
  isMobileMenuOpen: false,
};

// --- Slice Creator ---
export const createMobileMenuSlice: StateCreator<
  MobileMenuSlice,
  [],
  [],
  MobileMenuSlice
> = (set) => ({
  ...initialMobileMenuState,
  openMobileMenu: () => set({ isMobileMenuOpen: true }),
  closeMobileMenu: () => set({ isMobileMenuOpen: false }),
});

// --- Selectors ---
export const mobileMenu = {
  state: (s: MobileMenuSlice) => ({
    isOpen: s.isMobileMenuOpen,
    open: s.openMobileMenu,
    close: s.closeMobileMenu,
  }),
};

